import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {RequestBody} from '../../entity/core/request-body';
import {SearchResponse} from '../../entity/resource/search-response';

export default class SearchAgent {

  searchEntity = async (organizationId: string, requestBody: RequestBody): Promise<SearchResponse | []> => {
    return API.post(awsApiName, `/organizations/${organizationId}/search`, requestBody);
  }
}